import WOW from 'wow.js'
import { domReady } from '../utils'

const initWOW = () => new WOW().init()

export default domReady(initWOW)
